
(function () {
    angular.module('tmx-app').directive("tmxCustomHelpBox", tmxCustomHelpBox);

    function tmxCustomHelpBox() {
        return {
            scope: {

                enableCustomMessage: "=",
                fieldLabel:"="
            },
            restrict: 'E',
            templateUrl: 'common/directives/tmxcustomhelpbox/tmxcustomhelpbox.html',
            controller: tmxCustomHelpBoxCtrl,
            controllerAs: 'customhelpBox'
        };

    }

    function tmxCustomHelpBoxCtrl($scope) {

        var customhelpBox=this;
        customhelpBox.scope=$scope;
        customhelpBox.checkCustomViolation=function(message){
            if(angular.equals(message,true)){
                return "Exist";
            }
        }

    }

})();